import Container from '@/components/Container/Container';
import { useAuth } from '@/contexts/auth';
import { Navigate, Outlet } from 'react-router-dom';

function ProtectedLayout() {
  const { signed } = useAuth();
  if (!signed) {
    return <Navigate to="/login" />;
  }
  return (
    <Container>
      <Outlet />
    </Container>
  );
}

export default ProtectedLayout;
